import React from "react";
import HeaderNav from "../../header/header";
import {Button, Col, DatePicker, Form, Input, Layout, message, Row, Select, Space, Table} from "antd";
import "../css/SingleCreateFinancialClaim.css"
import CreateTable from "./createTable";
const { Content } = Layout;

const columns=[
    {
        title: 'Message',
        dataIndex: 'Message',
        // render: (text) => <a>{text}</a>,
    },
    {
        title: 'Material',
        dataIndex: 'Material',
        render:(text,record,index)=>{
            if(index>=data.length){
                return <Input />
            }else {
                return text
            }
        }
    },
    {
        title: 'Quantity',
        dataIndex: 'Quantity',
    },
    {
        title: 'End User Name',
        dataIndex: 'EndUserName',
    },
    {
        title: 'Unit Claim Value',
        dataIndex: 'UnitClaimValue',
    },
    {
        title: 'Claim Value',
        dataIndex: 'ClaimValue',
    },
    {
        title: 'Serial Number',
        dataIndex: 'SerialNumber',
    },
]
let data=[
    {
        key:1,
        Message:'There are some warnings',
        Material:'GXD0T69863',
        Quantity:'13',
        EndUserName:'',
        UnitClaimVlaue:'11.1',
        ClaimValue:'144.3',
        SerialNumber:'MJ0DQYLA'
    },
    {
        key:2,
        Message:'There are some warnings',
        Material:'GXD0T69863',
        Quantity:'13',
        EndUserName:'',
        UnitClaimVlaue:'11.1',
        ClaimValue:'144.3',
        SerialNumber:'MJ0DQYLA'
    }
]

const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User',
        name: record.name,
    }),
};
class CBSOCreateFinancialClaim extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            dataSource:data,
            count:data.length+1
        }
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
            key: count,
            Message:'There are some warnings',
            Material:'GXD0T69863',
            Quantity:'13',
            EndUserName:'',
            UnitClaimVlaue:'11.1',
            ClaimValue:'144.3',
            SerialNumber:'MJ0DQYLA'

        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
        });
    };
    onFinish(Values){
        console.log('Success:',Values)
    }
    onFinishFailed(Values){
        console.log('Error:',Values)
    }

    render() {
        const {dataSource} = this.state
        return <div>
            <HeaderNav parmas={'/CBSOCreateFinancialClaim'}/>
            <Layout className="site-layout-background SingleCreateFinancialClaim" style={{ padding: '24px 0' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 ,width: '1000px',margin: '0 auto'}}>
                    <h1 style={{marginLeft:'5%'}}>CBSO Create Financial Claim</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        // wrapperCol={{ span: 10}}
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="Claim Category"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="Sold to Party"
                                    rules={[{ required: true}]}
                                >
                                <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Bill to Party"
                                    name="Bill to Party"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="Sales Org"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Pricing Date"
                                    name="Pricing Date"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker style={{width:'100%'}} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Purchase Order Number"
                                    name="Purchase Order Number"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Channel"
                                    name="Channel"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Currency"
                                    name="Currency"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Payment Terms"
                                    name="Payment Terms"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="Sales Office"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Division"
                                    name="Division"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="BP-Reference"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="Claim Type"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Ship to Party"
                                    name="Ship to Party"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Contract Number"
                                    name="Contract Number"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Billing Strart Date"
                                    name="Billing Strart Date"
                                    rules={[{ required: false }]}
                                >
                                    <DatePicker style={{width:'100%'}} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Billing End Date "
                                    name="Billing End Date "
                                    rules={[{ required: false }]}
                                >
                                    <DatePicker style={{width:'100%'}} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Billing Frequency"
                                    name="Billing Frequency"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Comment"
                                    labelCol={{span:4}}
                                    name="Comment"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Billing Instruction"
                                    labelCol={{span:4}}
                                    name="Billing Instruction"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Hearder Text"
                                    labelCol={{span:4}}
                                    name="Hearder Text:"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Invoice Number"
                                    labelCol={{span:8}}
                                    name="Invoice Number"
                                    rules={[{ required: false }]}
                                >
                                    <Input suffix={<Button>Invoice Copy</Button>}/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Label"
                                    labelCol={{span:8}}
                                    name="Label"
                                    rules={[{ required: false }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item style={{textAlign:'right'}}>
                        </Form.Item>
                        <div style={{margin:'0 auto'}}>
                            <h1>Financial Claim Item</h1>
                            <CreateTable />
                            <Button style={{position: "relative",right: "-204px",bottom: "48px"}} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </div>
                    </Form>
                </Content>
            </Layout>
        </div>
    }
}

export default CBSOCreateFinancialClaim;